const translations = {
  fr: {
    userManagement: {
      usersManagementPageTitle: 'Gestion des utilisateurs',
      couldNotSendInvitationMessage: 'Impossible d\'envoyer l\'invitation',
      missingEmailMessage: 'Veuillez entrer une adresse courriel',
      invalidEmailMessage: 'Votre adresse courriel n\'est pas valide',
      missingNameMessage: 'Veuillez entrer un prénom',
      missingSurnameMessage: 'Veuillez entrer un nom',
      missingRoleMessage: 'Veuillez choisir au moins un rôle',
      inviteAUser: 'Inviter un utilisateur',
      roles: 'Rôles',
      couldNotSaveUserMessage: 'Une erreur est survenue lors de la sauvegarde',
      sendingInvitation: 'Envoi de l\'invitation en cours...',
      invitationSendSuccess: 'Invitation envoyée',
      couldNotDeleteUser: 'Impossible de supprimer l\'utilisateur, veuillez réessayer.',
      editUser: 'Modification d\'utilisateur',
      fullName: 'Nom',
      surname: 'Nom',
      name: 'Prénom',
      accountStatus: 'État du compte',
      active: 'Actif',
      invited: 'Invité',
      resendInvitation: 'Renvoyer invitation',
      deleteUserQuestion: 'Voulez-vous vraiment supprimer cet utilisateur ?',
      deleteUser: 'Supprimer cet utilisateur',
      manage: 'Gérer',
      invitation: 'Invitation',
      actions: 'Actions',
      noUserToManage: 'Il n\'y a pas d\'utilisateurs à gérer',
      couldNotLoadUsers: 'Une erreur est survenue lors du chargement des utilisateurs',
      rolesTable: 'Table des rôles',
      canGiveAccess: 'Peuvent donner accès',
      president: 'Président',
      generalDirector: 'Directeur général',
      salesDirector: 'Directeur des ventes',
      programDirector: 'Directeur de programmation',
      sales: 'Ventes',
      programming: 'Programmation',
      production: 'Production',
      technical: 'Technique',
    },
  },
  en: {
    userManagement: {
      usersManagementPageTitle: 'Users Management',
      couldNotSendInvitationMessage: 'Could not send invitation',
      missingEmailMessage: 'Please enter an email address',
      invalidEmailMessage: 'Enter a valid email address',
      missingNameMessage: 'Please enter a name',
      missingSurnameMessage: 'Please enter a surname',
      missingRoleMessage: 'Please choose at least one role',
      inviteAUser: 'Invite a User',
      roles: 'Roles',
      couldNotSaveUserMessage: 'An error occured while saving the user\'s modifications',
      sendingInvitation: 'Sending invitation...',
      invitationSendSuccess: 'Invitation sent successfully',
      couldNotDeleteUser: 'Could not delete user',
      editUser: 'Edit User',
      fullName: 'Name',
      surname: 'Surname',
      name: 'Name',
      accountStatus: 'Account status',
      active: 'Active',
      invited: 'Invited',
      resendInvitation: 'Resend invitation',
      deleteUserQuestion: 'Are you sure you want to delete this user?',
      deleteUser: 'Delete user',
      manage: 'Manage',
      invitation: 'Invitation',
      actions: 'Actions',
      noUserToManage: 'There is no user to manage',
      couldNotLoadUsers: 'Could not load users',
      rolesTable: 'Roles table',
      canGiveAccess: 'Can give access',
      president: 'President',
      generalDirector: 'General Manager',
      salesDirector: 'Sales director',
      programDirector: 'Program director',
      sales: 'Sales',
      programming: 'Programming',
      production: 'Production',
      technical: 'Technical',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/userManagement/i18n/userManagement.js